import { useState } from "react";

const MessageCell = ({ message }) => {
  const [showMore, setShowMore] = useState(false);
  const limit = 50;

  if (!message) return null;

  const isLong = message.length > limit;

  return (
    <>
      {showMore || !isLong
        ? message
        : message.substring(0, limit) + "..."}

      {isLong && (
        <span
          onClick={() => setShowMore(!showMore)}
          style={{
            color: "blue",
            cursor: "pointer",
            marginLeft: "6px",
          }}
        >
          {showMore ? "Less" : "More"}
        </span>
      )}
    </>
  );
};


export default MessageCell